import React, { useState, useEffect } from "react";
import "antd/dist/antd.css";
import { Badge } from "antd";
import StandardTableLayout from "../../layouts/StandardTableLayout/StandardTableLayout";
import StandardListLayout from "../../layouts/StandardTableLayout/StandardListLayout";
import { useDispatch, useSelector } from "react-redux";
import {
  FETCH_ALL_VEHICLE_MODEL,
  setVehicleModel,
  DELETE_VEHICLE_MODEL,
} from "../../store/fleet-store/reducer";

const VehicleModels = () => {
  const dispatch = useDispatch();
  const { organisationId } = useSelector(({ auth }) => auth.user);
  const { models } = useSelector(({ fleets }) => fleets.fleetReducer);
  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const columns = [
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      sorter: (a, b) => a.description.localeCompare(b.description),
    },

    {
      title: "Status",
      dataIndex: "active",
      key: "active",
      render: (status) => {
        let type = status === true ? "success" : "error";
        return <Badge status={type} text={status ? "Active" : "InActive"} />;
      },
      sorter: (a, b) => b.active - a.active,
    },
  ];

  const FETCH_DATA = () => {
    FETCH_ALL_VEHICLE_MODEL(organisationId)
      .then((data) => dispatch(setVehicleModel(data)))
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    FETCH_DATA();
  }, [organisationId]);

  useEffect(() => {
    const newDoc = [];
    models?.forEach((ele, index) => {
      let data = {
        _id: ele?._id,
        title: `${ele?.description}`,
        description: `${ele?.status ? "Active" : "Inactive"}`,
      };
      newDoc.push(data);
    });
    setDataList(newDoc);
  }, [models]);

  return (
    <div className="table-organisations table-payments">
      <div className="table-layouts">
        <div className="tables">
          <StandardTableLayout
            csvHeader={null}
            csvData={null}
            csvFileName={null}
            setIsLoading={setIsLoading}
            isLoading={isLoading}
            hierachy={[{ key: 1, label: "Vehicle Models" }]}
            dataSource={models}
            columns={columns}
            FETCH_DATA={FETCH_DATA}
            DELETE_FUNC={DELETE_VEHICLE_MODEL}
            table="fleet/vehicle/models"
          />
        </div>
        <div className="table-lists">
          <StandardListLayout
            csvHeader={null}
            csvData={null}
            csvFileName={null}
            setIsLoading={setIsLoading}
            isLoading={isLoading}
            hierachy={[{ key: 1, label: "Vehicle Models" }]}
            dataList={dataList}
            columns={columns}
            FETCH_DATA={FETCH_DATA}
            DELETE_FUNC={DELETE_VEHICLE_MODEL}
            table="fleet/vehicle/models"
          />
        </div>
      </div>
    </div>
  );
};

export default VehicleModels;
